// ******************** FORM ********************
export const FETCH_ASSET_GROUP_LOADING = 'FETCH_ASSET_GROUP_LOADING';
export const FETCH_ASSET_GROUP_SUCCESS = 'FETCH_ASSET_GROUP_SUCCESS';
export const FETCH_ASSET_GROUP_ERROR = 'FETCH_ASSET_GROUP_ERROR';

// ******************** ASSET DETAILS FORM ********************
export const FETCH_ASSET_DETAILS_LOADING = 'FETCH_ASSET_DETAILS_LOADING';
export const FETCH_ASSET_DETAILS_SUCCESS = 'FETCH_ASSET_DETAILS_SUCCESS';
export const FETCH_ASSET_DETAILS_ERROR = 'FETCH_ASSET_DETAILS_ERROR';
